import styled, { css } from 'styled-components';

import { TagButtonProps } from './types';

const commonStyles = css`
  height: 40px;
  width: fit-content;
  flex-shrink: 0;

  display: flex;
  align-items: center;
  flex-direction: row;

  ${({ theme }) => css`
    gap: ${theme.padding.extraSmall};
    padding: 0 ${theme.padding.small};
    border-radius: ${theme.borderRadius.big};
  `}
`;

export const Container = styled.div`
  ${commonStyles};
  cursor: default;

  ${({ theme }) => css`
    color: ${theme.colors.black.main};
    background-color: ${theme.colors.white.main};
  `}
`;

export const Button = styled.button<{ palette: TagButtonProps['palette'] }>`
  ${commonStyles};
  border: none;
  cursor: pointer;

  ${({ theme, palette = 'black' }) => css`
    color: ${theme.colors.white.main};
    background-color: ${theme.colors[palette].main};
    &:hover:enabled {
      color: ${theme.colors.white.hover};
      background-color: ${theme.colors[palette].hover};
    }
    &:active:enabled {
      color: ${theme.colors.white.active};
      background-color: ${theme.colors[palette].active};
    }
    &:disabled {
      cursor: default;
    }
  `}
`;
